import {useState, useRef} from 'react'
import {useNavigate} from 'react-router-dom'

import Style from './style'
import MyStoreTicket from './ui/MyStoreTicketRecord'
import GiveModal from './ui/GiveModal'

import MainHeader from 'widget/MainHeader'

import useGetMyStore from 'entity/store/useGetMyStore'
import useGetStoreTicketTypes from 'entity/store/useGetStoreTicketTypes'

import DTStyle from 'shared/style/detailTableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import DefaultModal from 'shared/ui/DefaultModal'
import DefaultButton from 'shared/ui/DefaultButton'
import useRoleCookie from 'shared/model/useRoleCookie'
import {
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
} from 'shared/constant/lookup/role'
import arrowDownIcon from 'shared/assets/ic_arrow_down.svg'
import usePostReturnTicket from 'entity/store/usePostReturnTicket'
import ChangePasswordModal from '../FranchiseManagerDetail/ui/ChangePasswordModal'
import usePutSelfPassword from 'entity/auth/usePutSelfPassword'

const MyStore = () => {
	const navigate = useNavigate()
	const [roleCookie] = useRoleCookie()

	const numberRef = useRef()
	const voucherTypeRef = useRef()

	const [isReturnModalOpen, setIsReturnModalOpen] = useState(false)
	const [isGiveModalOpen, setIsGiveModalOpen] = useState(false)
	const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)

	const [myStoreData] = useGetMyStore()
	const [ticketTypes, , refetchTicketTypes] = useGetStoreTicketTypes()
	const [changePasswordRequest, isPasswordChanging] = usePutSelfPassword()

	const handleModalReturnClose = () => {
		setIsReturnModalOpen(false)
		refetchTicketTypes()
	}

	const [removeTicket] = usePostReturnTicket(
		myStoreData?.data?.idx,
		numberRef,
		voucherTypeRef,
		handleModalReturnClose
	)

	const btnList = [
		...(roleCookie === ROLE_FRANCHISE_MANAGER
			? []
			: [
					{
						label: '매장 정보 수정',
						clickEvent: () => navigate('/store/my/edit'),
					},
					{
						label: '매장 이용권 반환',
						clickEvent: () => setIsReturnModalOpen(true),
					},
				]),
		{
			label: '매장 이용권 지급 & 회수',
			clickEvent: () => setIsGiveModalOpen(true),
		},
		...(roleCookie === ROLE_STORE_MANAGER
			? [
					{
						label: '비밀번호 변경',
						clickEvent: () => setIsPasswordModalOpen(true),
					},
				]
			: []),
	]

	const myDataList = [
		{
			label: 'IDX',
			value: myStoreData?.data?.idx,
		},
		{
			label: '상태',
			value: myStoreData?.data?.is_approve ? '승인' : '미승인',
		},
		{
			label: '이름',
			value: myStoreData?.data?.name,
		},
		{
			label: '연락처',
			value: myStoreData?.data?.contact,
		},
		{
			label: '가입 날짜',
			value: timestampCalculator(myStoreData?.data?.created_at),
		},
	]

	const myStoreDataList = [
		{
			label: '매장 이름',
			value: myStoreData?.data?.store_name,
		},
		{
			label: '매장 주소',
			value: myStoreData?.data?.store_address,
		},
	]

	const sortedVoucherTypes =
		ticketTypes?.data?.ticket_types?.sort((a, b) => a.idx - b.idx) || []

	const voucherTypeOptions = [
		{value: 'all', label: '== 모든 유형 =='},
		...(ticketTypes?.data?.ticket_types || [])
			.sort((a, b) => a.idx - b.idx)
			.map((voucher) => ({
				value: voucher.idx,
				label: voucher.name,
			})),
	]

	const formatExpirationDays = (days) => {
		if (days === null) return 'Unlimited'
		return `${days} days`
	}

	return (
		<>
			{isGiveModalOpen && (
				<GiveModal closeEvent={() => setIsGiveModalOpen(false)} />
			)}
			{isReturnModalOpen && (
				<DefaultModal
					title={'매장 이용권 반환'}
					closeEvent={handleModalReturnClose}
				>
					<Style.ModalReturnWrapper>
						<Style.SelectWrapper>
							<select ref={voucherTypeRef}>
								{voucherTypeOptions.map((option) => (
									<option key={option.value} value={option.value}>
										{option.label}
									</option>
								))}
							</select>
							<img src={arrowDownIcon} alt='arrow' />
						</Style.SelectWrapper>
						<Style.GiveDiv>
							<input placeholder='개수 입력' ref={numberRef} />
							<DefaultButton
								small
								fitWidth
								expandHeight
								clickEvent={removeTicket}
							>
								반환
							</DefaultButton>
						</Style.GiveDiv>
					</Style.ModalReturnWrapper>
				</DefaultModal>
			)}
			<Style.Wrapper>
				<MainHeader btnList={btnList} mobileLayout='default'>
					{roleCookie === ROLE_FRANCHISE_MANAGER
						? '매장 이용권 사용 기록'
						: '매장'}
				</MainHeader>
				{roleCookie === ROLE_FRANCHISE_MANAGER ? (
					<></>
				) : (
					<Style.AreaDiv>
						<h2>내 정보</h2>
						<DTStyle.TableDiv>
							{myDataList?.map((elem, idx) => (
								<DTStyle.TableElement key={idx}>
									<h2>{elem?.label}</h2>
									<p>{elem?.value}</p>
								</DTStyle.TableElement>
							))}
						</DTStyle.TableDiv>
					</Style.AreaDiv>
				)}

				{roleCookie === ROLE_FRANCHISE_MANAGER ? (
					<></>
				) : (
					<Style.AreaDiv>
						<h2>내 매장 정보</h2>
						<DTStyle.TableDiv>
							{myStoreDataList?.map((elem, idx) => (
								<DTStyle.TableElement key={idx}>
									<h2>{elem?.label}</h2>
									<p>{elem?.value}</p>
								</DTStyle.TableElement>
							))}
						</DTStyle.TableDiv>
					</Style.AreaDiv>
				)}

				{roleCookie === ROLE_FRANCHISE_MANAGER ? (
					<></>
				) : (
					<Style.AreaDiv>
						<h2>프랜차이즈 로고 이미지</h2>
						{myStoreData?.data?.logo_img ? (
							<Style.LogoImg
								src={myStoreData.data.logo_img}
								alt='프랜차이즈 로고'
							/>
						) : (
							<p>로고 이미지가 없습니다.</p>
						)}
					</Style.AreaDiv>
				)}

				{/* 매장 이용권 유형 */}
				{roleCookie === ROLE_STORE_MANAGER && (
					<Style.AreaDiv>
						<h2>매장 이용권 유형</h2>
						<Style.VoucherTableWrapper>
							<Style.VoucherTableDiv>
								{sortedVoucherTypes.map((voucher, index) => (
									<Style.VoucherItem key={voucher.idx}>
										<Style.VoucherRow>
											<Style.VoucherLabelLeft>
												{index + 1}
											</Style.VoucherLabelLeft>
											<p>{voucher.name}</p>
										</Style.VoucherRow>

										<Style.VoucherRowRight>
											<Style.VoucherLabelRight>수량</Style.VoucherLabelRight>
											<p>{voucher.holding_count || 0}</p>
										</Style.VoucherRowRight>

										<Style.VoucherRowRight>
											<Style.VoucherLabelRight>
												만료 시간
											</Style.VoucherLabelRight>
											<p>{formatExpirationDays(voucher.expiration_days)}</p>
										</Style.VoucherRowRight>
									</Style.VoucherItem>
								))}

								{sortedVoucherTypes?.length === 0 && (
									<Style.VoucherItem>
										<Style.VoucherRow>
											<Style.VoucherLabelLeft>-</Style.VoucherLabelLeft>
											<p>-</p>
										</Style.VoucherRow>

										<Style.VoucherRowRight>
											<Style.VoucherLabelRight>수량</Style.VoucherLabelRight>
											<p>-</p>
										</Style.VoucherRowRight>

										<Style.VoucherRowRight>
											<Style.VoucherLabelRight>
												만료 시간
											</Style.VoucherLabelRight>
											<p>-</p>
										</Style.VoucherRowRight>
									</Style.VoucherItem>
								)}
							</Style.VoucherTableDiv>
						</Style.VoucherTableWrapper>
					</Style.AreaDiv>
				)}

				<MyStoreTicket />
			</Style.Wrapper>
			{isPasswordModalOpen && (
				<ChangePasswordModal
					isOpen={isPasswordModalOpen}
					onClose={() => setIsPasswordModalOpen(false)}
					onSubmit={(newPassword) => changePasswordRequest(newPassword)}
					isLoading={isPasswordChanging}
				/>
			)}
		</>
	)
}

export default MyStore
